





































































































































import { Component, Vue } from "vue-property-decorator";
import LoginHeader from "@/components/header/ULoginHeader.vue";
import Header from "@/components/header/UHeader.vue";
import Footer from "@/components/Footer.vue";
import ContactApi from "@/services/ContactsApi";
import AuthModule from "@/store/auth";
import { Contacts } from "@/api/lab-base-api-client";
import logger from "@/lib/log/logger";

@Component({
  components: {
    Header,
    LoginHeader,
    Footer,
  },
})
export default class Contact extends Vue {
  private isCompDialog = false;

  // アカウントの取得
  private get me() {
    return AuthModule.me;
  }

  // 各フォームの初期値
  private form: Contacts = { title: "", name: "", email: "", content: "" };

  // 送信が押された時
  private async submit() {
    try {
      await ContactApi.instance.sendContacts(this.form);
    } catch (err) {
      if (err instanceof Error) {
        logger.frontError(`${err.name}: ${err.message}`);
        console.log(err);
      }
    }
    this.isCompDialog = true;
  }
}
